var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c(_vm.component,{key:_vm.$route.meta.key || _vm.$route.fullPath,tag:"component",staticClass:"page"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }